import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  TextField,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Typography,
  Checkbox,
} from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { GalleryDialog } from "@icarius-common/galleryDialog";
import useHandleForm from "./useHandleForm";
import GalleryButtonAndDisplay from "@icarius-common/galleryDialog/components/galleryButtonAndDisplay";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";

const gridStyle = { height: 75, padding: "0px 10px" };

const Form = (props) => {

  const {
    data,
    codeList,
    accessTypeList,
    processList,
    userMenuList,
    detailTableList,
    create,
    modify,
    isAdmin,
  } = props;

  const dispatch = useDispatch();

  const [imagesDialogIsOpen, setImagesDialogIsOpen] = useState(false);

  const openValidationError = () => {
    dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
  }

  const openControlValidationError = () => {
    dispatch(openSnackbarAction({ msg: getLocalizedString("ifEnteringIntegrityControlDataEnterAll3Fields"), severity: "error", duration: 10000 }));
  }

  const {
    isCreate,
    formData,
    setFormValue,
    submit
  } = useHandleForm(data, codeList, create, modify, openValidationError, openControlValidationError);

  const handleWithCheckChange = () => {
    if (!codeList.find(item => item.key === formData.code)?.canUseCheck) {
      dispatch(openSnackbarAction({
        msg: getLocalizedString("systemTableCheckChange"),
        severity: "error",
        duration: null
      }));
      return;
    }

    if ((!Boolean(formData.accessType) || formData.accessType === 'ME') && !formData.withCheck) {
      dispatch(openSnackbarAction({
        msg: getLocalizedString("toIndicateThatTheTableHasVisadoYouMustEnterAccessType"),
        severity: "error",
        duration: null
      }));
      return;
    }

    setFormValue(!Boolean(formData.withCheck), "withCheck");
  }

  return (
    <>
      <Grid container item xs={12} direction="row" style={{ paddingTop: 10 }}>
        <Grid container item xs={12}>
          <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
            <FormControl style={{ width: "100%" }}>
              <InputLabel required id={`label-code`}>{getLocalizedString("tableCode")}</InputLabel>
              <Select
                disabled={!isCreate}
                value={formData.code}
                labelId={`label-code`}
                id={`select-code`}
                onChange={(e) => setFormValue(e.target.value, "code")}
                margin={"none"}
              >
                {
                  codeList?.map(item => (
                    <MenuItem
                      className={"whiteText"}
                      key={item.key}
                      value={item.key}>
                      {`${item.value} (${item.key})`}
                    </MenuItem>
                  ))
                }
              </Select>
            </FormControl>
          </Grid>
          <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
            <TextField
              required
              disabled={!isCreate}
              fullWidth
              margin={"none"}
              label={getLocalizedString("versionCode")}
              onChange={(e) => setFormValue(e.target.value, "codver")}
              value={formData.codver}
              inputProps={{ maxLength: 30 }}
            />
          </Grid>
          <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
            <TextField
              required
              fullWidth
              margin={"none"}
              label={getLocalizedString("tableName")}
              onChange={(e) => setFormValue(e.target.value, "name")}
              value={formData.name}
              inputProps={{ maxLength: 30 }}
            />
          </Grid>
          <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
            <TextField
              required
              fullWidth
              margin={"none"}
              label={getLocalizedString("tableGroup")}
              onChange={(e) => setFormValue(e.target.value, "group")}
              value={formData.group}
              inputProps={{ maxLength: 40 }}
            />
          </Grid>
          <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
            <FormControl style={{ width: "100%" }}>
              <InputLabel required id={`label-accessType`}>{getLocalizedString("accessType")}</InputLabel>
              <Select
                value={formData.accessType}
                labelId={`label-accessType`}
                id={`select-accessType`}
                onChange={(e) => setFormValue(e.target.value, "accessType")}
                margin={"none"}
              >
                {
                  accessTypeList?.map(item => (
                    <MenuItem
                      className={"whiteText"}
                      key={item.key}
                      value={item.key}>
                      {item.value}
                    </MenuItem>
                  ))
                }
              </Select>
            </FormControl>
          </Grid>
          <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
            <FormControl style={{ width: "100%" }}>
              <InputLabel required id={`label-editorActive`}>{getLocalizedString("activeEditor")}</InputLabel>
              <Select
                value={formData.editorActive}
                labelId={`label-editorActive`}
                id={`select-editorActive`}
                onChange={(e) => setFormValue(e.target.value, "editorActive")}
                margin={"none"}
              >
                {
                  [
                    { key: 'N', value: getLocalizedString("no") },
                    { key: 'Y', value: getLocalizedString("yes") },
                    { key: 'M', value: getLocalizedString("modificationOnly") },
                    { key: 'V', value: getLocalizedString("viewOnly") },
                  ].map(item => (
                    <MenuItem
                      className={"whiteText"}
                      key={item.key}
                      value={item.key}>
                      {item.value}
                    </MenuItem>
                  ))
                }
              </Select>
            </FormControl>
          </Grid>
          <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
            <FormControl style={{ width: "100%" }}>
              <InputLabel required id={`label-importerActive`}>{getLocalizedString("importerActive")}</InputLabel>
              <Select
                value={formData.importerActive}
                labelId={`label-importerActive`}
                id={`select-importerActive`}
                onChange={(e) => setFormValue(e.target.value, "importerActive")}
                margin={"none"}
              >
                {
                  [{ key: 'N', value: getLocalizedString("no") }, { key: 'Y', value: getLocalizedString("yes") }].map(item => (
                    <MenuItem
                      className={"whiteText"}
                      key={item.key}
                      value={item.key}>
                      {item.value}
                    </MenuItem>
                  ))
                }
              </Select>
            </FormControl>
          </Grid>
          <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
            <FormControl style={{ width: "100%" }}>
              <InputLabel shrink id={`label-process`}>{getLocalizedString("relatedSpecialProcess")}</InputLabel>
              <Select
                value={formData.process}
                labelId={`label-process`}
                id={`select-process`}
                onChange={(e) => setFormValue(e.target.value, "process")}
                margin={"none"}
                displayEmpty
              >
                <MenuItem
                  className={"whiteText"}
                  value={''}>
                  {getLocalizedString("none")}
                </MenuItem>
                {
                  processList?.map(item => (
                    <MenuItem
                      className={"whiteText"}
                      key={item.key}
                      value={item.key}>
                      {item.value}
                    </MenuItem>
                  ))
                }
              </Select>
            </FormControl>
          </Grid>
          {
            formData.accessType !== 'ME' && !formData.isDetailTable &&
            <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
              <FormControl style={{ width: "100%" }}>
                <InputLabel shrink id={`label-userMenu`}>{getLocalizedString("userMenu")}</InputLabel>
                <Select
                  value={formData.userMenu}
                  labelId={`label-userMenu`}
                  id={`select-userMenu`}
                  onChange={(e) => setFormValue(e.target.value, "userMenu")}
                  margin={"none"}
                  displayEmpty
                >
                  <MenuItem
                    className={"whiteText"}
                    value={''}>
                    {getLocalizedString("none")}
                  </MenuItem>
                  {
                    userMenuList?.map(item => (
                      <MenuItem
                        className={"whiteText"}
                        key={item.key}
                        value={item.key}>
                        {item.value}
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
          }
          <Grid container item alignItems="center" xs={12} style={gridStyle}>
            <TextField
              fullWidth
              margin={"none"}
              label={getLocalizedString("fieldsForDataFilterInGrid")}
              onChange={(e) => setFormValue(e.target.value, "filterByFields")}
              value={formData.filterByFields}
              inputProps={{ maxLength: 254 }}
              helperText={getLocalizedString("fieldsForDataFilterInGridHelperText")}
            />
          </Grid>
          <Grid container item alignItems="center" xs={12} style={{ ...gridStyle, marginTop: 10 }}>
            <TextField
              fullWidth
              margin={"none"}
              label={getLocalizedString("dataGridSortingFields")}
              onChange={(e) => setFormValue(e.target.value, "orderByFields")}
              value={formData.orderByFields}
              inputProps={{ maxLength: 254 }}
              helperText={getLocalizedString("dataGridSortingFieldsHelperText")}
            />
          </Grid>
          <Grid container item alignItems="center" xs={12} style={gridStyle}>
            <div
              style={{ display: "flex", alignItems: "center", cursor: "pointer", paddingRight: 20 }}
              onClick={handleWithCheckChange}
            >
              <Typography className="whiteText" variant="subtitle1" style={{ display: "inline-block" }}>
                {getLocalizedString("withVisa")}
              </Typography>
              <Checkbox checked={formData.withCheck} />
            </div>
            <div
              style={{ display: "flex", alignItems: "center", cursor: "pointer", paddingRight: 10 }}
              onClick={() => setFormValue(!formData.isDetailTable, 'isDetailTable')}
            >
              <Typography className="whiteText" variant="subtitle1" style={{ display: "inline-block" }}>
                {getLocalizedString("isDetailTable")}
              </Typography>
              <Checkbox checked={formData.isDetailTable} />
            </div>
            {
              !Boolean(formData.isDetailTable) &&
              <Grid container item alignItems="center" xs={6} style={gridStyle}>
                <FormControl style={{ width: "100%" }}>
                  <InputLabel shrink id={`label-associatedDetailTable`}>{getLocalizedString("relatedDetailTable")}</InputLabel>
                  <Select
                    value={formData.associatedDetailTable}
                    labelId={`label-associatedDetailTable`}
                    id={`select-associatedDetailTable`}
                    onChange={(e) => setFormValue(e.target.value, "associatedDetailTable")}
                    margin={"none"}
                    displayEmpty
                  >
                    <MenuItem value={''}>
                      {getLocalizedString("none")}
                    </MenuItem>
                    {
                      detailTableList?.map(item => (
                        <MenuItem
                          className={"whiteText"}
                          key={item.key}
                          value={item.key}>
                          {item.value}
                        </MenuItem>
                      ))
                    }
                  </Select>
                </FormControl>
              </Grid>
            }
          </Grid>
          <Grid container item alignItems="center" xs={12} style={{ ...gridStyle, height: 30, marginTop: 10 }}>
            <Typography className="whiteText">
              {getLocalizedString("forExistenceControlDuringRecordDeletion")}
            </Typography>
          </Grid>
          <Grid container item alignItems="center" sm={12} md={4} style={gridStyle}>
            <TextField
              required={Boolean(formData.controlCode || formData.relatedTable || formData.relatedTableCode)}
              fullWidth
              margin={"none"}
              label={getLocalizedString("tableControlField")}
              onChange={(e) => setFormValue(e.target.value, "controlCode")}
              value={formData.controlCode}
              inputProps={{ maxLength: 18 }}
            />
          </Grid>
          <Grid container item alignItems="center" sm={12} md={4} style={gridStyle}>
            <TextField
              required={Boolean(formData.controlCode || formData.relatedTable || formData.relatedTableCode)}
              fullWidth
              margin={"none"}
              label={getLocalizedString("relatedTable")}
              onChange={(e) => setFormValue(e.target.value, "relatedTable")}
              value={formData.relatedTable}
              inputProps={{ maxLength: 18 }}
            />
          </Grid>
          <Grid container item alignItems="center" sm={12} md={4} style={gridStyle}>
            <TextField
              required={Boolean(formData.controlCode || formData.relatedTable || formData.relatedTableCode)}
              fullWidth
              margin={"none"}
              label={getLocalizedString("relatedTableField")}
              onChange={(e) => setFormValue(e.target.value, "relatedTableCode")}
              value={formData.relatedTableCode}
              inputProps={{ maxLength: 18 }}
            />
          </Grid>
          <Grid container item alignItems="center" xs={12} style={{ padding: 10 }}>
            <TextFieldMultiline
              fullWidth
              label={getLocalizedString("sqlToExecuteWhenSaving")}
              helperText={getLocalizedString("sqlToExecuteWhenSavingHelperText")}
              rows={10}
              margin={"none"}
              value={formData['sqlInsert']}
              onChange={(e) => setFormValue(e.target.value, "sqlInsert")}
              inputProps={{ spellCheck: 'false' }}
            />
          </Grid>
          <Grid container item alignItems="center" xs={12} style={{ padding: 10 }}>
            <TextFieldMultiline
              fullWidth
              label={getLocalizedString("sqlToExecuteWhenDeleting")}
              helperText={getLocalizedString("sqlToExecuteWhenDeletingHelperText")}
              rows={10}
              margin={"none"}
              value={formData['sqlDelete']}
              onChange={(e) => setFormValue(e.target.value, "sqlDelete")}
              inputProps={{ spellCheck: 'false' }}
            />
          </Grid>
          <Grid container item alignItems="center" xs={12} style={{ padding: 10 }}>
            <TextFieldMultiline
              fullWidth
              label={getLocalizedString("operationModeSql")}
              helperText={
                <>
                  {getLocalizedString("operationModeSqlHelperText")}
                  <br />
                  {getLocalizedString("sqlVariablesAvailableHelperText")}
                </>
              }
              rows={10}
              margin={"none"}
              value={formData['operationModeSql']}
              onChange={(e) => setFormValue(e.target.value, "operationModeSql")}
              inputProps={{ spellCheck: 'false' }}
            />
          </Grid>
          <Grid container item alignItems="center" xs={12} style={{ padding: 10 }}>
            <TextFieldMultiline
              fullWidth
              label={getLocalizedString("recordBlockSql")}
              helperText={
                <>
                  {getLocalizedString("recordBlockSqlHelperText")}
                  <br />
                  {getLocalizedString("recordBlockSqlVariablesHelperText")}
                </>
              }
              rows={10}
              margin={"none"}
              value={formData['recordBlockSql']}
              onChange={(e) => setFormValue(e.target.value, "recordBlockSql")}
              inputProps={{ spellCheck: 'false' }}
            />
          </Grid>
          <GalleryButtonAndDisplay
            image={formData.image}
            handleOpenGallery={() => setImagesDialogIsOpen(true)}
          />
        </Grid>
        <Grid container item xs={12} justify={"flex-end"} alignItems="center" style={{ visibility: isAdmin ? 'visible' : 'hidden', paddingBottom: 20 }}>
          <ButtonDialogAction isAccept onClick={submit} text={getLocalizedString("save")} />
        </Grid>
      </Grid>
      {
        imagesDialogIsOpen &&
        <GalleryDialog
          open={imagesDialogIsOpen}
          initialValue={formData.image}
          type={"news"}
          handleSubmit={(image) => setFormValue(image, "image")}
          handleClose={() => setImagesDialogIsOpen(false)}
        />
      }
    </>
  );
}

export default Form;
